module.exports = __webpack_public_path__ + "static/media/wilson-logo.c8220d80.png";